// @ts-check
import { Appsettings } from "../Appsettings";
import User from "../models/users/user";
import { SingJWT2 } from "../utils/jwtTools";
import { setSessionToken } from "../models/users/user";
import axios from "axios";

/**
 * @param {string} token
 * @returns {Promise<User>}
 */
async function getUserByToken(token) {
  //const url = path.join(Appsettings.ApiUrl, "autenticacion", token);
  const url = Appsettings.ApiUrl + "/autenticacion/" + token;
  const requser = await axios.get(url);
  if (requser.status !== 200) {
    throw new Error("Error al obtener el usuario");
  }
  const res = requser.data;
  if (res.verificado) {
    const user = res.usuario;
    return new User(user.uuid, user.name, user.lastname, user.role);
  } else {
    throw new Error("Usuario no autorizado");
  }
}

/**
 * @param {string} username
 * @param {string} password
 * @returns {Promise<void>}
 */
async function login(username, password) {
  const payload = {
    username,
    password,
  };
  const token = SingJWT2(payload, { expiresIn: "1h" });
  const method = "POST";
  const headers = {
    "Content-Type": "application/json",
  };
  const body = JSON.stringify({ token });
  //const url = path.join(Appsettings.ApiUrl, "login");
  const url = Appsettings.ApiUrl + "/login";
  try {
    const req = await axios.post(url, body, { headers });
    if (req.status !== 200) {
      throw new Error("Error al iniciar sesión");
    }
    const res = req.data;
    if (res) {
      const SessionToken = res.db.token;
      const user = res.db.usuario;
      Appsettings.ApiToken = SessionToken;
      Appsettings.User = new User(
        user.uuid,
        user.name,
        user.lastname,
        user.role,
      );
      setSessionToken(SessionToken);
    } else {
      throw new Error("Error al iniciar sesión");
    }
  } catch (e) {
    throw new Error("Error de conexion con el servidor");
  }
}

export { getUserByToken, login };
